export const FETCH_MODE = {
  SEARCH: 'search',
  LIST: 'list',
};

export const DEBOUNCE_TIME_MS = 500;

export const TEMPLATE_STATUS = {
  READY: 'Ready',
  DELETED: 'Deleted',
  DRAFT: 'Draft',
};
